<template>
  <section class="sales-rate">
    <div class="rate-box" v-for="(item, index) in rateOptions" :key="index">
      <div>{{ item }}</div>
      <el-rate v-model="optionValues[index]" :disabled="disabled" :max="10" @change="handleChange"></el-rate>
    </div>
    <div v-if="hasOther">
      <div>{{ otherName }}</div>
      <el-input v-model="otherValue" :disabled="disabled" :placeholder="placeholder" @input="handleChange"></el-input>
    </div>
  </section>
</template>

<script>
export default {
  name: "SalesRate",
  props: {
    value: {
      type: [String, Array],
      default: null,
    },
    rateOptions: {
      type: Array,
      default: () => [],
    },
    hasOther: {
      type: Boolean,
      default: false,
    },
    otherName: {
      type: String,
      default: "其它原因",
    },
    placeholder: {
      type: String,
      default: "请输入其它原因",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      optionValues: [],
      otherValue: "",
    };
  },
  mounted() {
    if (this.value) {
      const arr = this.value.split("\n");
      this.rateOptions.map((item, index) => {
        const itemArr = arr[index].split("：")[1];
        const num = Number(itemArr);
        this.optionValues[index] = num;
      });
      if (this.hasOther && arr.length > this.rateOptions.length) {
        this.otherValue = arr[arr.length - 1].split("：")[1];
      }
    } else {
      this.rateOptions.map((item) => {
        this.optionValues.push(0);
      });
    }
  },
  methods: {
    handleChange(val) {
      const valuesList = this.rateOptions.map((item, index) => {
        return `${item}：${this.optionValues[index]}`;
      });
      const otherStr = this.otherValue ? `\n${this.otherName}：${this.otherValue}` : "";
      const str = valuesList.join("\n");
      this.$emit("input", str + otherStr);
    },
  },
};
</script>

<style lang="less" scoped>
.sales-rate {
  width: 100%;
  color: #606266;
  .rate-box {
    div {
      &:first-child {
        line-height: 32px;
      }
    }
    margin-bottom: 16px;
  }
  :deep(.el-rate) {
    display: flex;
    justify-content: space-between;
    .el-rate__icon {
      font-size: 24px;
    }
    .el-icon-star-on {
      transform: scale(1.25);
    }
  }
}
</style>
